export {
    KEY_REG_PROMPT_COUNT,
    KEY_LAST_REG_PROMPT_SESSION,
    REG_PROMPT_SESSION,
    KEY_GOOGLE_ONE_TAP_PROMPT_COUNT,
    KEY_SINCE_REG_PROMPT,
    KEY_LAST_GOOGLE_ONE_TAP_PROMT,
} from '../src/visitCountConstants';
